<template>
  <div>
    <!--blog Section start-->
    <div class="page-margin">
      <!--breadcrumb start-->
      <div class="breadcrumb-bg">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-text-center d-align-center">
              <h2 class="title">
                <span
                  >นโยบายความเป็นส่วนตัว และข้อกำหนดการใช้บริการ
                  <b>WESERVE GO</b></span
                >
              </h2>
              <div>
                <small>ฉบับปรับปรุงข้อมูล : 1 มิถุนายน 2565</small>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 col-text-center">
              <nav aria-label="breadcrumb" class="blog-bradcrumb ">
                <ol class="breadcrumb bg-transparent mb-0">
                  <li class="breadcrumb-item"><a :href="'/'">Home</a></li>
                  <li class="breadcrumb-item active"><a href="#">Policy</a></li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!--breadcrumb end -->

      <!-- sign in -->
      <section>
        <div class="innerpage-decor">
          <div class="innerpage-circle1">
            <img src="@/assets/images/Testimonial2.png" alt="" />
          </div>
          <div class="innerpage-circle2">
            <img src="@/assets/images/Testimonial2.png" alt="" />
          </div>
        </div>
        <!--faq in -->
        <div class="faq">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div role="tablist" id="accordion">
                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">ข้อกำหนดการใช้บริการ </span>
                    </div>

                    <div class="card-body">
                      <p>
                        กรุณาอ่านเงื่อนไขข้อกำหนดการใช้งานโดยละเอียด
                        หนังสือฉบับนี้เป็นข้อตกลงแบบอิเล็กทรอนิกส์
                        และเมื่อคุณลงทะเบียนหรือใช้งานส่วนใดส่วนหนึ่งของแอพพลิเคชัน
                        หมายความว่า คุณยืนยันว่าได้อ่าน ยอมรับ
                        และตกลงในเงื่อนไขการใช้งานเหล่านี้
                        และยินยอมเข้าผูกพันตามเงื่อนไขที่มี หากคุณไม่ยินยอมเข้า
                        ผูกพันตามเงื่อนไขการใช้งานเหล่านี้
                        คุณจะต้องไม่เข้าถึงหรือใช้ส่วนหนึ่งส่วนใดของระบบ
                        เงื่อนไขการใช้งานเหล่านี้จะก่อให้เกิดข้อตกลงทางกฎหมายที่มีผลผูกพันระหว่างคุณ
                        ในฐานะผู้ใช้บุคคล และนิติบุคคล
                        <b>บริษัท วีเสิร์ฟโก เอเซีย จำกัด</b>
                        ที่เกี่ยวข้องที่มีตามที่กำหนดไว้
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">คำนิยาม </span>
                    </div>

                    <div class="card-body">
                      <ul>
                        <li>
                          <b>“บริษัท”</b>หมายถึง บริษัท วีเสิร์ฟโก เอเซีย จำกัด
                          ซึ่งเป็นเจ้าของและดำเนินการแอปพลิเคชัน WESERVE
                          GOโดยบริษัทไม่ได้ทำหน้าที่เป็นผู้จัดส่งซึ่งผู้จัดส่งจะให้บริการด้านขนส่งทั้งหมดโดยตรงแก่คุณ
                          ตามหน้าที่ในฐานะผู้รับจ้างอิสระ
                          บุคคลที่สามที่ดำเนินธุรกิจจากบัญชีของเขา/เธอเอง
                          ไม่ใช่ภายใต้การจ้างงานของบริษัท
                        </li>
                        <li>
                          <b>“คนขับ”</b>
                          หมายถึง ผู้เช่าใช้ระบบของบริษัทเพื่อรับงาน
                          ซึ่งจะทำการขนส่งผู้โดยสารในนามของบริษัท
                          และภายใต้การกำกับดูแล และการควบคุมคุณภาพของบริษัท
                        </li>

                        <li>
                          <b>“บริการ”</b>
                          หมายถึง
                          บริการที่ผู้ใช้สั่งให้คนขับทำการจัดส่งผู้โดยสาร
                          และวิธีการจัดส่งจะเป็นการขนส่งทางบกภายในประเทศไทยโดยใช้รถยนต์
                        </li>
                        <li>
                          <b>“สถานที่ส่ง”</b> หมายถึง สถานที่ในประเทศไทย
                          ซึ่งเป็นสถานที่ที่ผู้ใช้เลือกให้ผู้จัดส่งทำการส่งสิ่งของที่จัดส่งภายใต้เขตพื้นที่การให้บริการของบริษัท
                        </li>
                        <li>
                          <b>“แอปพลิเคชัน WESERVE GO”</b> หมายถึง
                          แอปพลิเคชันแพลตฟอร์ม
                          และระบบบริการสนับสนุนที่เกี่ยวข้องอื่นๆ
                          ที่บริษัทพัฒนาขึ้น โดยระบบที่ WESERVE GO
                          ให้บริการนั้นจะไม่รวมบริการจัดส่งเนื่องจากคนขับจะเป็นผู้ให้บริการแก่ผู้ใช้โดยตรง
                        </li>
                        <li>
                          <b>“ผู้ใช้”</b> หมายถึง
                          ผู้ใช้บริการที่ลงทะเบียนไว้ในแอปพลิเคชันสำหรับผู้ใช้
                        </li>
                        <li>
                          <b>“นโยบาย”</b> หมายถึง นโยบายและแนวทางปฏิบัติ
                          หรือคำสั่งสำหรับผู้ใช้แอปพลิเคชัน WESERVE GO
                          จะแจ้งให้คุณทราบเป็นระยะผ่านช่องทางสื่อสารของบริษัท
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">หน้าที่ความรับผิดชอบของคุณ </span>
                    </div>

                    <div class="card-body">
                      <p>
                        คุณยืนยันว่าคุณมีสิทธิและอำนาจเต็มที่ในการเข้าทำ
                        และผูกพันตามเงื่อนไขการใช้งานเหล่านี้
                        และการปฏิบัติหน้าที่ตามพันธะผูกพันที่คุณมี
                        ภายใต้เงื่อนไขการใช้งานเหล่านี้
                      </p>
                      <ul>
                        <li>
                          คุณมีอายุขั้นต่ำ ตามกฎหมายที่มีบังคับใช้
                          ที่จะสามารถเข้าผูกพันตามเงื่อนไขการใช้งานเหล่านี้ได้
                        </li>
                        <li>
                          คุณจะปฏิบัติตามกฎหมาย
                          และนโยบายที่มีบังคับใช้ทั้งหมดเพื่อวัตถุประสงค์ตามเจตนาของการใช้บริการเท่านั้น
                        </li>
                        <li>
                          คุณต้องตรวจสอบข้อมูลใดๆที่คุณมอบให้ WESERVE GO
                          (หรือผู้อื่นมอบให้ในนามของคุณ) ผ่านทางแอปพลิเคชัน
                          WESERVE GO จะต้องเป็นข้อมูลที่ถูกต้อง เป็นปัจจุบัน
                          และไม่ชวนให้เข้าใจผิด
                        </li>
                        <li>
                          คุณต้องไม่มีส่วนเกี่ยวข้องในการฉ้อฉล การหลอกลวง
                          หรือการกระทำที่ทำให้เข้าใจผิดใดๆ
                        </li>
                        <li>
                          คุณต้องไม่สร้างความเสียหาย
                          หรือหลบเลี่ยงการปฏิบัติการเครือข่ายที่เหมาะสมใดๆ
                          ที่เป็นฐานตั้งของแอปพลิเคชัน WESERVE GO
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >การมีปฏิสัมพันธ์ของคุณกับผู้จัดส่งและเจ้าหน้าที่อื่นๆ
                      </span>
                    </div>

                    <div class="card-body">
                      <p>
                        การเรียกใช้บริการจากผู้จัดส่งจะก่อให้เกิดความสัมพันธ์โดยตรงระหว่างคุณและผู้จัดส่ง
                        WESERVE GO จะไม่รับผิดชอบหรือรับผิดต่อการกระทำ
                        หรือการละเว้นไม่กระทำการใดๆ
                        ของผู้จัดส่งที่มีความสัมพันธ์กับคุณ
                        ทั้งนี้จะอยู่ภายใต้ขอบเขตสูงสุดที่กฎหมายที่มีบังคับใช้อนุญาตไว้
                        คุณจะต้องรับผิดชอบแต่เพียงผู้เดียวสำหรับพันธะผูกพันหรือความรับผิดชอบใด
                        ๆ
                        ต่อผู้จัดส่งหรือบุคคลที่สามอื่นใดที่เกิดขึ้นจากการที่คุณใช้บริการ
                        <br />
                        <br />
                        คุณตกลงภายใต้เงื่อนไขการใช้งานเหล่านี้
                      </p>
                      <ul>
                        <li>
                          จะปฏิบัติต่อคนขับและเจ้าหน้าที่อื่นๆด้วยความเคารพ
                          และสอดคล้องกับนโยบาย
                          และจะไม่ข้องเกี่ยวในพฤติกรรมหรือกิจกรรมที่ไม่ชอบด้วยกฎหมาย
                          เป็นการข่มขู่ หรือการคุกคาม ในขณะที่ใช้บริการ
                        </li>
                        <li>
                          จะไม่สร้างความเสียหายใดๆ ต่อทรัพย์สินของบุคคลที่สาม
                        </li>
                        <li>
                          จะไม่ติดต่อคนขับเเพื่อวัตถุประสงค์อื่นใด
                          นอกเหนือจากการรับและใช้บริการขนส่ง
                        </li>
                        <li>
                          เพื่อให้เกิดความชัดเจน WESERVE GO
                          จะไม่มีการรับรองผู้ให้บริการบุคคลที่สาม
                          (รวมถึงผู้จัดส่ง) แอปพลิเคชัน หรือเว็บไซต์ใด ๆ
                          ที่มีหรือคุณเชื่อมต่อเข้าหาผ่านแอปพลิเคชัน WESERVE GO
                          และไม่ว่าในกรณีใดก็ตาม บริษัทจะไม่รับผิดชอบต่อเนื้อหา
                          ผลิตภัณฑ์ บริการ หรือวัสดุใด ๆ
                          เกี่ยวกับหรือที่ได้มาจากผู้ให้บริการบุคคลที่สามดังกล่าว
                          การให้คะแนนผู้จัดส่ง และพันธมิตรคู่ค้า
                          รายใดก็ตามในแอปพลิเคชัน WESERVE GO
                          จะมีเจตนาเพื่อให้ผู้ใช้ได้ระบุคะแนนความพึงพอใจ
                          แต่ไม่ได้ก่อให้เกิดการรับรอง (หรือในทางอื่น) โดย
                          WESERVE GO
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">ข้อร้องเรียน </span>
                    </div>

                    <div class="card-body">
                      <ul>
                        <li>
                          หากคุณมีเรื่องร้องเรียนเกี่ยวกับบริการที่คุณได้รับ
                          WESERVE GO
                          จะรับข้อร้องเรียนดังกล่าวและดูแลจัดการเรื่องร้องเรียนของ
                          WESERVE GO โดย
                          คุณยินยอมที่จะให้ความร่วมมืออย่างเต็มที่กับกระบวนการดังกล่าว
                          และตกลงที่จะยื่นร้องเรียนที่คุณอาจมีผ่านทางแอปพลิเคชัน
                          WESERVE GO
                          ขอสงวนสิทธิในการส่งต่อเรื่องร้องเรียนของคุณไปยังผู้จัดส่งหรือพันธมิตรที่เกี่ยวข้อง
                        </li>
                        <li>
                          หาก WESERVE GO
                          ได้รับเรื่องร้องเรียนจากผู้จัดส่งหรือบุคคลอื่นเกี่ยวกับคุณ
                          WESERVE GO มีสิทธิในการส่งเรื่องร้องเรียนถึงคุณ
                          หรือรับมือกับเรื่องร้องเรียนดังกล่าวผ่านกระบวนการดูแลจัดการเรื่องร้องเรียน
                          และคุณจะต้องให้ความร่วมมืออย่างเต็มที่กับกระบวนการดังกล่าวด้วยเช่นกัน
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">บัญชีของคุณ</span>
                    </div>

                    <div class="card-body">
                      <ul>
                        <li>
                          ในการเข้าถึงระบบในฐานะผู้ใช้ คุณต้องลงทะเบียน
                          และเก็บรักษาบัญชีไว้ในฐานะผู้ใช้ของแอปพลิเคชัน WESERVE
                          GO
                        </li>
                        <li>
                          คุณต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นในบัญชีของคุณ
                          <ul>
                            <li>
                              ต้องเก็บรักษาข้อมูลบัญชีของคุณ
                              (ซึ่งรวมถึงรายละเอียดการล็อกอิน
                              และรายละเอียดการชำระเงินของคุณ)
                              ไว้เป็นความลับและดูแลให้ปลอดภัย
                            </li>
                            <li>
                              ต้องไม่มอบสิทธิให้ผู้อื่นเข้าถึงบัญชีของคุณได้
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">นโยบายความเป็นส่วนตัว</span>
                    </div>

                    <div class="card-body">
                      <p>
                        นโยบายความเป็นส่วนตัวนี้
                        อธิบายข้อมูลความเป็นส่วนตัวของท่านที่ท่านได้ให้ไว้กับทางบริษัท
                        วีเสิร์ฟโก เอเซีย จำกัด. (ซึ่งต่อไปในที่นี้เรียกว่า
                        “WESERVE GO”) เมื่อท่านใช้บริการ
                        (ซึ่งต่อไปในที่นี้เรียกว่า “ผู้ใช้บริการ”) กับทาง
                        WESERVE GO ผ่านทางแอปพลิเคชันทางโทรศัพท์มือถือ (ซึ่งต่อ
                        ไปในที่นี้เรียกว่า “แอปพลิเคชัน”)
                        โปรดอ่านนโยบายความเป็นส่วนตัว
                        และทำความเข้าใจก่อนการใช้บริการ ท่านตกลง และอนุญาตให้ทาง
                        WESERVE GO รวบรวมการใช้
                        และโอนข้อมูลของท่านตามที่ได้กำหนดในนโยบายความเป็นส่วนตัวนี้
                        เมื่อท่านเยี่ยมชมแอปพลิเคชัน และ
                        /หรือใช้บริการผ่านทางแอปพลิเคชัน ซึ่ง WESERVE GO
                        ให้บริการในการขนส่ง (ซึ่งต่อ ไปในที่นี้เรียกว่า
                        “บริการ”)
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >WESERVE GO ได้ทำการรวบรวมข้อมูลอะไรของท่านบ้าง</span
                      >
                    </div>

                    <div class="card-body">
                      <p>
                        WESERVE GO จะทำการรวบรวมข้อมูลของท่าน
                        เมื่อท่านได้มีสั่งซื้อสินค้า หรือใช้บริการกับทาง WESERVE
                        GO หรือใช้งานผ่านแอปพลิเคชัน นอกจากนี้ WESERVE GO
                        จะรวบรวมข้อมูลของท่าน เมื่อท่านกรอกแบบสอบถามใดๆ
                        ก็ตามเสร็จสิ้นแล้ว
                        และเมื่อท่านได้เข้าเยี่ยมชมแอปพลิเคชัน
                        ข้อมูลการใช้งานจะถูกรวบรวมไว้ใน คุกกี้ (
                        ตามข้ออธิบายในข้อต่อไป ) WESERVE GO
                        จะทำการรวบรวมข้อมูลของท่านเพื่อพิสูจน์ตัวตนผู้ใช้
                        (โดยข้อมูลจะมี ชื่อ,อีเมล,ที่อยู่ ,เบอร์โทรศัพท์
                        ,ตำแหน่งสถานที่ตั้งปัจจุบัน เป็นต้น)
                        เมื่อท่านอนุญาตเท่านั้น WESERVE GO
                        จะทำการเก็บรวบรวมข้อมูลเหล่านี้เพื่อดำเนินการใช้งานตามที่เสนอผ่านทางเว็บไซต์
                        รวมถึงให้ข้อเสนอ และข้อมูลเกี่ยวกับ WESERVE GO
                        รวมถึงบริการต่างๆที่ท่านอาจจะสนใจ WESERVE GO
                        จะรวบรวมข้อมูลส่วนตัวของท่านผ่านการสั่ง บริการออนไลน์
                        การร่วมกิจกรรม การลงทะเบียนเพื่อรับข้อมูลข่าวสารจากทาง
                        WESERVE GO การเปิดบัญชีผู้ใช้งาน การส่งข้อความผ่านทาง
                        contact us
                        หรือผ่านทางช่องทางอื่นๆของทางเว็บไซต์หรือผ่านทางโฆษณา
                        การทำ แบบสอบถามและการตลาดทางตรง WESERVE GO
                        จะไม่เก็บข้อมูลสำคัญของท่าน
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">คุกกี้ (Cookies)</span>
                    </div>

                    <div class="card-body">
                      <p>
                        คุกกี้เป็นไฟล์ข้อมูลเล็กๆ ที่ส่งผ่านทางอุปกรณ์ของท่าน
                        ซึ่งจดจำ และพิสูจน์อุปกรณ์การใช้งานของท่าน
                        และอนุญาตให้อุปกรณ์ของท่านจดจำข้อมูลจากทางแอปพลิเคชัน
                        ของ WESERVE GO เพื่อความรวดเร็วในการใช้งาน ในครั้งต่อไป
                        ข้อมูลบางอย่างที่ทางแอปพลิเคชันได้เก็บรวบรวม
                        ไม่สามารถพิสูจน์ตัวตนผู้ใช้งานได้
                        แต่จะติดตามการเข้าใช้งานแอปพลิเคชันของท่าน เพื่อที่ทาง
                        WESERVE GO จะได้ทราบลักษณะการใช้งานของลูกค้า
                        และเพื่อเป็นการปรับปรุงการสั่ง หรือการให้บริการออนไลน์
                        WESERVE GO จะนำข้อมูลเหล่า นี้โดยใช้คุกกี้
                        คุกกี้ไม่ได้เก็บข้อมูลใดๆที่พิสูจน์ตัวตนของท่านและ
                        WESERVE GOไม่ได้ใช้ คุกกี้เพื่อทำการเก็บข้อมูลดังกล่าว
                        แต่ WESERVE GO
                        จะเก็บข้อมูลส่วนตัวของท่านเมื่อท่านได้ให้ข้อมูลส่วนตัวกับทาง
                        WESERVE GO เท่านั้น WESERVE GO
                        จะเก็บข้อมูลทางเทคนิคจากโทรศัพท์มือถือของท่านหรือการใช้งานแอปพลิเคชันผ่านทางโทรศัพท์มือถือของ
                        ท่าน
                        และ/หรือเว็บบราวเซอร์ของท่านต้องสามารถอนุญาตให้ท่านปฏิเสธการใช้งานคุกกี้ได้ถ้าท่านต้องการ
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >การใช้ข้อมูลส่วนตัวของท่านที่รวบรวมโดย WESERVE GO</span
                      >
                    </div>

                    <div class="card-body">
                      <p>
                        ท่านยินยอมให้ WESERVE GO
                        สามารถรวบรวมและใช้ข้อมูลส่วนตัวของท่านในการดำเนินการและส่งของ
                        รวมถึงบริการอื่นๆที่ท่าน ได้สั่งไว้กับทาง แอปพลิเคชัน
                        ท่านยินยอมให้ WESERVE GO เปิดเผยข้อมูลส่วนตัวของท่าน
                        ประกอบไปด้วย ชื่อ อีเมล ที่อยู่
                        และเบอร์โทรศัพท์กับผู้ส่งของ พนักงานของ WESERVE GO
                        หรือบุคคลภายนอกที่ให้บริการ ของกับ WESERVE GO
                        ท่านยินยอมให้ WESERVE GO ใช้ข้อมูลส่วนตัวของ ท่าน
                        สำหรับวัตถุประสงค์ใน การโฆษณาหรือการตลาดทางตรงเพื่อแจ้ง
                        รายละเอียดของทางเว็บไซต์รวมถึงสินค้าและการบริการของ
                        WESERVE GO หรือเรื่องอื่นๆที่ท่านอาจสนใจ WESERVE GO
                        อาจเปิดเผยข้อมูลส่วนตัวของท่าน และ ท่านยินยอมให้ WESERVE
                        GO เปิดเผยข้อมูลส่วนตัวของท่าน กับบุคคลดังต่อ ไปนี้ -
                        องค์กรอื่นๆภายในกลุ่มบริษัท WESERVE GO-
                        บุคคลภายนอกที่ได้รับการว่าจ้างโดย WESERVE GO
                        หรือสมาชิกท่านอื่นในกลุ่มบริษัท WESERVE GO
                        ที่ปฏิบัติหน้าที่แทน WESERVE GO
                        หรือทำการส่งสินค้าและให้บริการแทน WESERVE GO
                        หากท่านไม่ต้องการรับข่าวสารจาก WESERVE GO
                        หรือไม่ต้องการให้ WESERVE GO
                        เปิดเผยข้อมูลส่วนตัวของท่านกับบุคคลภายนอก
                        กรุณาแจ้งให้เราทราบได้ที่ info@weservego.asia
                        หรือทำตามขั้นตอนเมื่อท่านได้รับข่าวสารจาก WESERVE
                        GOในอีเมล์ของท่าน WESERVE GO จะดำเนินการตามคำขอของท่าน
                        โดยเร็วที่สุดหลังจากที่ได้รับแจ้ง
                        โปรดทราบว่าการใช้บุคคลภายนอกดำเนินการยกเลิกการใช้บริการ
                        นั่นหมายถึงว่า WESERVE GO
                        จะไม่สามารถให้บริการท่านได้อีกต่อไป WESERVE
                        GOขอสงวนสิทธิ์ในการเปิดเผยข้อมูลส่วนตัวของท่านหากมีเหตุจำเป็นในทางกฎหมาย
                        หรือเพื่อเป็นการปกป้องสิทธิ และทรัพย์สินของ WESERVE GO
                        หรือบุคคลภายนอก
                        หรือเพื่อหลีกเหลี่ยงความเสียหายที่อาจเกิดขึ้นกับผู้อื่น
                        ในกรณีที่มีการขายกิจการ หรือการควบบริษัท
                        เราอาจถ่ายโอนข้อมูลส่วนตัวของท่านไปยังบริษัทที่เกี่ยวข้อง
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >การเข้าถึงข้อมูลส่วนตัวของผู้ใช้บริการ</span
                      >
                    </div>

                    <div class="card-body">
                      <p>
                        WESERVE GO
                        จะเก็บข้อมูลส่วนตัวของท่านไว้อย่างถูกต้องสมบูรณ์และอัพเดทอยู่เสมอและไม่ทำการบิดเบือนข้อมูลใดๆ
                        กรุณาแจ้งให้เราทราบ หากท่านต้องการเปลี่ยนแปลง แก้ไข
                        หรือปรับปรุงข้อมูลส่วนตัวที่ท่านได้ให้ไว้กับ WESERVE GO
                        ทางเราจะรีบดำเนินการตามคำขอของท่านโดยเร็วที่สุดหลังจากที่ได้รับแจ้ง
                        และหากท่านต้องการสำเนาเกี่ยวกับข้อมูลดังกล่าว
                        กรุณาแจ้งให้เราทราบได้ที่ info@weservego.asia ทาง
                        WESERVE GO
                        ขอสงวนสิทธิ์ในการเรียกเก็บค่าธรรมเนียมในการดำเนินการตามคำขอของท่านเพื่อเป็นไปตามกฎหมายที่กำหนดไว้
                        หาก WESERVE GO ได้รับแจ้ง การลบบัญชีผู้ใช้งาน
                        มิได้หมายความว่า
                        ข้อมูลส่วนตัวของท่านที่ให้ไว้กับทางเราจะถูกลบทิ้งไปโดยอัตโนมัติ
                        หากท่านมีความประสงค์ให้ WESERVE GO
                        ทำการลบข้อมูลส่วนตัวของท่านด้วย
                        กรุณาทำตามขั้นตอนที่ให้ไว้ข้างต้น โปรดทราบว่า
                        การลบข้อมูลส่วนตัวออกจากระบบของ WESERVE GO
                        หมายถึงว่าท่านยกเลิกการใช้บริการจากทางเราทั้งหมด
                        ทางเราไม่อาจดำเนินการตามคำขอของท่าน หากมีข้อ
                        กำหนดทางกฎหมายในการเก็บรักษาข้อมูลส่วนตัว (ถ้ามี)
                        เราจะให้ท่านต้องยืนยันตัวตนก่อน
                        โดยทำการส่งเอกสารสำเนาข้อมูลส่วนตัวของท่านให้กับทาง
                        WESERVE GO ก่อน
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class=""
                        >การรักษาความปลอดภัยและการเก็บข้อมูลในข้อมูลส่วนบุคคล</span
                      >
                    </div>

                    <div class="card-body">
                      <p>
                        WESERVE GO
                        จะเก็บรักษาข้อมูลส่วนตัวของท่านให้ปลอดภัยที่สุดและป้องกันไม่ให้มีการนำข้อมูลส่วนตัวของท่านไปใช้ในทางที่ผิด
                        การก้าวกาย ความเป็นส่วนตัว การทำข้อมูลสูญหาย
                        การนำข้อมูลส่วนตัวของท่านไปใช้โดยไม่ได้รับอนุญาต
                        รวมถึงการเปลี่ยนแปลงหรือเปิดเผยข้อมูลของท่าน WESERVE GO
                        จะทำลายข้อมูลส่วนตัวของท่านที่มีทั้งหมด
                        หากท่านไม่ประสงค์ที่จะใช้งานแล้วภายใต้ข้อ
                        กำหนดนโยบายความเป็นส่วนตัวนี้ (ข้อกำหนดจากข้างบน)
                        เมื่อท่านตั้งรหัสผ่านเพื่อเขาใช้
                        บริการของทางเว็บไซต์ท่านต้องเก็บรหัสผ่านดังกล่าวไว้เป็นความลับ
                        ไม่ควรบอกรหัสดังกล่าวกับผู้อื่น
                        ด้วยลักษณะการใช้งานอินเตอร์เน็ต WESERVE GO
                        ไม่สามารถรับรองความปลอดภัย
                        ขณะที่ท่านได้ทำการส่งผ่านข้อมูลส่วนตัวของท่านให้กับเรา
                        และ
                        ท่านยอมรับว่าท่านได้ทำการเปิดเผยข้อมูลส่วนตัวของท่านให้กับเราโดยยอมรับเป็นความเสี่ยงของตัวท่านเอง
                        โปรดแจ้งให้เราทราบทันทีหากท่านทราบว่า
                        มีการใช้ข้อมูลส่วนตัวของท่านผ่านทางเว็บไซต์โดยไม่ได้รับอนุญาต
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว </span>
                    </div>

                    <div class="card-body">
                      <p>
                        ทาง WESERVE GO ขอสงวนสิทธิ์ในการแก้ไข
                        นโยบายความเป็นส่วนตัวนี้โดยทั้งหมดหรือเฉพาะบางส่วน
                        โดยการเปลี่ยนแปลงดังกล่าวทาง WESERVE GO
                        จะแจ้งให้ท่านทราบผ่านทางแอปพลิเคชันหรือผ่านทางอีเมลตามที่เห็นสมควร
                        โดยไม่บอกกล่าวล่วงหน้า
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">แอปพลิเคชัน </span>
                    </div>

                    <div class="card-body">
                      <p>
                        ทางแอปพลิเคชันของ WESERVE GO
                        มีการเชื่อมต่อกับแอปพลิเคชันอื่นๆ
                        แต่นโยบายความเป็นส่วนตัวนี้ใช้ได้กับทางแอปพลิเคชันของเราเท่า
                        นั้น ดังนั้น
                        ท่านมีความจำเป็นต้องอ่านนโยบายความเป็นส่วนตัวของแอปพลิเคชันอื่นๆ
                        ที่ท่านกำลังใช้งานอยู่ด้วย
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="">การติดต่อ </span>
                    </div>

                    <div class="card-body">
                      <p>
                        หากท่านมีขอเสนอแนะหรือต้องการสอบถามข้อมูลเพิ่มเติมและคำขอใดๆ
                        ที่เกี่ยวข้องกับการใช้ข้อมูลส่วนตัวของท่านกับทาง WESERVE
                        GO ท่านสามารถส่งคำขอมาได้ ที่
                        <a href="mailto:info@weservego.asia"
                          >info@weservego.asia</a
                        >

                        ทางเรายินดีให้คำแนะนำและบริการที่ดีที่สุดแก่ท่าน
                      </p>
                    </div>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div class="card-header" role="tab">
                      <span class="text-danger"
                        >*ให้ยึดข้อกำหนดการใช้บริการและนโยบายความเป็นส่วนตัวฉบับภาษาไทยนี้ไปก่อนจนกว่าฉบับภาษาอังกฤษจะแล้วเสร็จ
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- faq up -->
      </section>
      <!-- sign up -->
      <!--blog Section end-->
    </div>
    <!--Footer Section start-->
    <Footer />
    <js />
    <!--Footer Section End-->
  </div>
</template>
<script>
export default {
  name: 'Policy',
};
</script>

<style scoped>
.card-body p {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
  font-size: inherit;
}
.card-body ul {
  list-style: circle;
}
</style>



// WEBPACK FOOTER //
// src/pages/policies/policy.vue